import { CIRCULAR_UPDATES, CIRCULAR_UPDATES_ERROR, CIRCULAR_UPDATES_HIDE_ERROR, CIRCULAR_UPDATES_START_LOADER, CIRCULAR_UPDATES_STOP_LOADER, } from "@frameworks/web/redux/interfaces/StaticFooter/iCircularUpdate";
import store from "@frameworks/web/redux/store";
class CircularUpdateActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getCircularUpdate(data) {
        this.dispatch({
            type: CIRCULAR_UPDATES,
            payload: { data },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: CIRCULAR_UPDATES_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: CIRCULAR_UPDATES_HIDE_ERROR,
        });
    }
    loader() {
        this.dispatch({
            type: CIRCULAR_UPDATES_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: CIRCULAR_UPDATES_STOP_LOADER,
        });
    }
}
export default CircularUpdateActions;
